// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1300":"56ac1cd2","9934":"22b808db"}[chunkId] + ".chunk.css";
};